export default __webpack_public_path__ + "static/media/köide-24-25.edf17b08.png";